import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Apollo } from 'apollo-angular';
import { InstalacionService } from 'src/app/services/instalacion.service';
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: 'app-nueva-instalacion',
  templateUrl: './nueva-instalacion.component.html',
  styleUrls: ['./nueva-instalacion.component.scss']
})
export class NuevaInstalacionComponent implements OnInit {
  isLinear = false;
  datosInstalacion: any={};

   constructor(private formBuilder: FormBuilder, private apollo: Apollo, private instalacionService: InstalacionService, public dialog: MatDialog) {
    this.buildForm();
  }


  ngOnInit(): void {
  }

  private buildForm(){
    this.datosInstalacion = this.formBuilder.group({
      nombre: ['', [Validators.required]],
      cliente: ['',[Validators.required]],
      grupo: [''],
    });

    }
  
  save(event:Event){
    event.preventDefault();
    const value = this.datosInstalacion.value;
    console.log(value);
  }

  addInstalacion(){
    console.log(this.datosInstalacion.value)
    this.apollo.mutate({
      mutation: this.instalacionService.addInstalacion(),
      variables: {
        "input": {
          "data": {
            "nombre": this.datosInstalacion.value.nombre,
            "cliente": [{
            "nombreComercial": this.datosInstalacion.value.cliente
             }],
            /* "agrupaciones": this.datosInstalacion.value.grupo */
          }
        }

      }
    }).subscribe(({data}) => {
      console.log('OK', data)
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }

}
